module.exports = __webpack_public_path__ + "img/SKWINKELNetActieKPICA526C.3ba37589.png";